import { Output } from "valibot";

import { IntegrationHandler } from "shared/integrations";
import { LocaleSchema } from "shared/schemas";

import ZenDeskOrFreshDeskIntegration from "./ZenDeskIntegration";

export interface IChatIntegration {
  integration?: IntegrationHandler;
  generationLanguage: Output<typeof LocaleSchema>;
  botAvatar: string;
  chatId: string;
  token: string;
  onFinish?: () => void;
}

export default function Integration(props: IChatIntegration) {
  const {
    integration,
    generationLanguage,
    botAvatar,
    chatId,
    token,
    onFinish,
  } = props;
  if (!integration) {
    return null;
  }
  if (integration.type === "zendesk" || integration.type === "freshdesk") {
    return (
      <ZenDeskOrFreshDeskIntegration
        botAvatar={botAvatar}
        generationLanguage={generationLanguage}
        integration={integration}
        chatId={chatId}
        token={token}
        onFinish={onFinish}
        isFreshDesk={integration.type === "freshdesk"}
      />
    );
  }
  return <></>;
}
